import * as React from 'react';
import { MarkAsFavorite } from '../../../components/MarkAsFavorite';
import * as vars from '../../../consts/variables';
import { formatItineraryInfo } from '../../../helpers/cruiseSearchHelper';
import { __ } from '../../../helpers/TranslationService';
import { IShip } from '../../../interfaces';
import CruiseShipTitle from './CruiseShipTitle';

const styles: Record<string, React.CSSProperties> = {
    iconStyle: {
        width: '20px',
        height: '15px',
        cursor: 'pointer',
        color: vars.softBlack,
    },
    filledHeartIcon: {
        color: vars.softRed,
    },
};

interface Props {
    startHarbour?: string;
    reviewsAttributes?: any;
    ship: IShip;
    nid: number;
    title: string;
    operator?: any;
    zone?: string;
    nights?: number;
    waypoints?: any;
}

const CruiseHeader = (props: Props) => {
    const {
        startHarbour,
        reviewsAttributes,
        ship,
        nid,
        title,
        operator,
        zone,
        nights,
        waypoints,
    } = props;
    const cruisePageTitle = operator?.isDreamlinesPackage
        ? title
        : `${zone} ${__('from', 'dreamlines')} ${startHarbour} ${__('with the', 'dreamlines')} ${
              ship.title
          }`;
    const waypointsHarboursArr = waypoints?.length
        ? waypoints.filter((waypoint) => !!waypoint.city).map((item) => item.city)
        : [];
    const uniqueWayPointCities = Array.from(new Set(waypointsHarboursArr));
    const nightsPortsDaysAtSea = formatItineraryInfo(nights, uniqueWayPointCities.length) + ' ';

    return (
        <div className="cruise-header-mobile">
            <div className="cruise-header-mobile_infoText">
                <span className="cruise-header-mobile_companyText">{operator?.title}</span>
                <span className="cruise-header-mobile_fromShipIdText"># {nid}</span>
                <MarkAsFavorite
                    cruiseNid={nid}
                    dropShadow="none"
                    iconStyle={styles.iconStyle}
                    filledIconStyle={{ ...styles.iconStyle, ...styles.filledHeartIcon }}
                />
            </div>
            <CruiseShipTitle title={cruisePageTitle} ship={ship} />

            <div className="cruise-header-mobile_row">
                {startHarbour && (
                    <div className="cruise-header-mobile_harbourRow">
                        <span className="cruise-header-mobile_fromText">
                            {nightsPortsDaysAtSea} {__('with the', 'dreamlines')} {ship.title}
                        </span>
                    </div>
                )}
            </div>
        </div>
    );
};
export default CruiseHeader;
